var render = function render(){var _vm=this,_c=_vm._self._c;return _c('legal-page-layout',{attrs:{"title":_vm.$t('terms.title'),"updated":_vm.$t('terms.updated'),"paragraphs":_vm.$t('terms.paragraphs')}})
}
var staticRenderFns = []

export { render, staticRenderFns }